'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import CustomWidgetPropTypes from 'DesignData/propTypes/customWidgets';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import UIFormLabel from 'UIComponents/form/UIFormLabel';
import Small from 'UIComponents/elements/Small';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { GROUP } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { STYLE } from 'ContentUtils/constants/CustomWidgetFieldGroupTabTypes';
import { getFieldDepth } from 'DesignData/helpers/customWidgetFieldsHelper';
import * as customWidgetBuffersSelectors from 'DesignData/selectors/customWidgetBuffers';
import { getFieldCreateOptions } from 'DesignData/selectors/customWidgetEditorOptions';
import { MAX_NESTING_DEPTH } from 'DesignData/constants/CustomWidgets';
import * as CustomWidgetBufferActions from 'DesignData/actions/CustomWidgetBuffers';
import * as CustomWidgetEditorOptionsActions from 'DesignData/actions/CustomWidgetEditorOptions';
import CreateFieldDropdown from 'DesignEditorsUI/components/customWidgetEditor/sidebar/CreateFieldDropdown';
import FieldsTable from 'DesignEditorsUI/components/customWidgetEditor/sidebar/main/fieldsTable/FieldsTable';
import { compose } from 'redux';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

function makeMapStateToProps() {
  const getCustomWidgetBufferFields = customWidgetBuffersSelectors.makeGetCustomWidgetBufferFields();
  return (state, props) => {
    const fields = getCustomWidgetBufferFields(state, props);
    const {
      field
    } = props;
    return {
      depth: field ? getFieldDepth(fields, field.id) : 0,
      fieldCreateOptions: getFieldCreateOptions(state, props)
    };
  };
}

const mapDispatchToProps = {
  createField: CustomWidgetBufferActions.createField,
  toggleFieldGrouping: CustomWidgetEditorOptionsActions.toggleFieldGrouping
};

class FieldGroupChildrenList extends Component {
  constructor(...args) {
    super(...args);

    this.onChildCreate = fieldType => {
      const {
        createField,
        customWidgetId,
        field,
        fieldCreateOptions
      } = this.props;
      const newField = new CustomWidgetField({
        type: fieldType,
        isNew: true,
        fieldCreateOptions
      });
      createField(customWidgetId, newField, field.id);
    };

    this.onGroupClick = () => {
      const {
        customWidgetId,
        toggleFieldGrouping
      } = this.props;
      toggleFieldGrouping(customWidgetId);
    };
  }

  get canContainChildren() {
    return this.props.depth < MAX_NESTING_DEPTH - 1;
  }

  renderChildren() {
    const {
      field,
      depth,
      customWidgetId,
      fieldName,
      readOnly
    } = this.props;

    if (!field.children || !field.children.length) {
      const messageKey = !this.canContainChildren ? 'tooDeep' : 'noChildren';
      return /*#__PURE__*/_jsx("div", {
        className: "p-bottom-3",
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: i18nKey(`group.${messageKey}`)
          })
        })
      });
    }

    return /*#__PURE__*/_jsx(FieldsTable, {
      customWidgetId: customWidgetId,
      fields: field.children,
      fieldName: fieldName,
      depth: depth + 1,
      isReadOnly: readOnly
    });
  }

  renderGroupControls() {
    const {
      isFieldGroupingActive,
      readOnly,
      customWidgetId,
      field
    } = this.props;

    if (isFieldGroupingActive || !this.canContainChildren || readOnly) {
      return null;
    }

    return /*#__PURE__*/_jsxs(UIFlex, {
      align: "baseline",
      justify: "between",
      children: [/*#__PURE__*/_jsx(UIFormLabel, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey(`defaultLabels.${GROUP}`)
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(CreateFieldDropdown, {
          customWidgetId: customWidgetId,
          onFieldCreate: this.onChildCreate,
          isStyleTab: field.tab === STYLE
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: this.onGroupClick,
          use: "link",
          children: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('group.groupButtonLabel')
            })
          })
        })]
      })]
    });
  }

  render() {
    return /*#__PURE__*/_jsxs("div", {
      className: "group-content-options",
      children: [this.renderGroupControls(), this.renderChildren()]
    });
  }

}

FieldGroupChildrenList.propTypes = {
  createField: PropTypes.func.isRequired,
  customWidgetId: CustomWidgetPropTypes.customWidgetId.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  fieldCreateOptions: PropTypes.object.isRequired,
  fieldName: PropTypes.string,
  depth: PropTypes.number,
  isFieldGroupingActive: PropTypes.bool.isRequired,
  toggleFieldGrouping: PropTypes.func.isRequired,
  readOnly: PropTypes.bool
};
FieldGroupChildrenList.defaultProps = {
  depth: 0,
  fieldsErrors: {}
};
export default compose(connect(makeMapStateToProps, mapDispatchToProps))(FieldGroupChildrenList);